/**
 * 商品ページのギャラリー：data-tata-defer-src / srcset で出力した画像（product-thumbnail の defer_media）を戻す
 *
 * - スマホ（横スクロールのスライダー）：スライダーの幅の半分まで近づいたら読み込む
 *   （3 枚目以降が LCP の 1 枚目と回線を奪い合わないようにする）
 * - PC（縦並び）：すぐに戻し、あとはブラウザ標準の loading="lazy" に任せる
 */
(() => {
  const DEFERRED = 'img[data-tata-defer-src], img[data-tata-defer-srcset]';

  const restore = (img) => {
    const { tataDeferSrcset: srcset, tataDeferSrc: src } = img.dataset;
    if (srcset) img.srcset = srcset;
    if (src) img.src = src;
    img.removeAttribute('data-tata-defer-srcset');
    img.removeAttribute('data-tata-defer-src');
  };

  const initList = (list) => {
    if (list.dataset.tataGalleryDeferInit === 'true') return;
    list.dataset.tataGalleryDeferInit = 'true';

    let observer = null;
    const pending = () => list.querySelectorAll(DEFERRED);
    const isSlider = () => list.scrollWidth > list.clientWidth + 1;

    const restoreAll = () => {
      pending().forEach(restore);
      if (observer) {
        observer.disconnect();
        observer = null;
      }
    };

    const sync = () => {
      if (!pending().length) return;
      if (!isSlider() || !('IntersectionObserver' in window)) {
        restoreAll();
        return;
      }
      if (observer) return;
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.querySelectorAll(DEFERRED).forEach(restore);
            observer.unobserve(entry.target);
          });
        },
        // 半画面ぶん先まで。表示中の次のスライド（右端に少し見えている 2 枚目）を見たら、その次を読み込む
        { root: list, rootMargin: '0px 50% 0px 50%' }
      );
      list.querySelectorAll('.product__media-item').forEach((item) => {
        if (item.querySelector(DEFERRED)) observer.observe(item);
      });
    };

    sync();

    // バリエーション切り替えで product-info.js がスライドを追加・並べ替えたときも、新しいスライドを監視する
    new MutationObserver(() => {
      if (!pending().length) return;
      if (!isSlider() || !observer) {
        if (observer) observer.disconnect();
        observer = null;
        sync();
        return;
      }
      list.querySelectorAll('.product__media-item').forEach((item) => {
        if (item.querySelector(DEFERRED)) observer.observe(item);
      });
    }).observe(list, { childList: true });
    // スマホ → PC に幅が変わったら（縦並びになったら）残りを戻す
    window.addEventListener('resize', () => {
      if (pending().length && !isSlider()) restoreAll();
    }, { passive: true });
  };

  const init = () => document.querySelectorAll('.product__media-list').forEach(initList);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
